// extracted by mini-css-extract-plugin
export default {"dragAndDrop":"styles_dragAndDrop__6oaQv","input":"styles_input__nE7cp","dragArea":"styles_dragArea__NKvpa","containerError":"styles_containerError__gBMDK"};